module.exports = __webpack_public_path__ + "img/babel.a8400c11.png";